import React, {useEffect, useState} from 'react'
import styles from './skillBuilding.module.scss'

import API from 'Class/API'

import Error from 'Components/Feedback/Error'
import ListItem from './list.item'
import ScrollView from 'Components/UI/ScrollView'
import Spinner from 'Components/Feedback/Spinner'
import TextField from 'Components/UI/Field/TextField'

const List = ({className = '', community = 0, loading, onDelete, onEdit, onLoading, onSelect, selected}) =>
{
    const [error, setError] = useState(null)
    const [list, setList] = useState(null)
    const [searchQuery, setSearchQuery] = useState('')
    const [searchTimeout, setSearchTimeout] = useState(null)

    const loadActivities = async () =>
    {
        onLoading && onLoading(true)
        const {list, error, message} = await API.RequestAsyncWhenReady('skillActivities/list', {
            community,
            filter: searchQuery
        })
        onLoading && onLoading(false)
        setError(error ? message : null)
        setList(list)
    }

    const onDeleted = (item) =>
    {
        setList(list.filter(i => i.id !== item.id))
    }

    const onSearch = (_, value) =>
    {
        clearTimeout(searchTimeout)
        if (searchQuery === value)
        {
            return
        }
        onLoading && onLoading(true)
        setSearchTimeout(setTimeout(() =>
        {
            setSearchQuery(value)
        }, 500))
    }

    useEffect(() => { loadActivities() }, [searchQuery])

    let content = null

    if (loading)
    {
        content = <Spinner overlay={true}/>
    }
    else if (error)
    {
        content = (
            <Error
                button='Retry'
                className={styles.error}
                label={error}
                onClick={loadActivities}
            />
        )
    }
    else if (list && list.length)
    {
        content = list?.map(item => (
            <ListItem
                {...item}
                community={community}
                data={item}
                key={item.id}
                onDelete={onDelete}
                onDeleted={() => onDeleted(item)}
                onEdit={onEdit}
                onSelect={onSelect}
                selected={selected?.id === item.id}
            />
        ))
    } else
    {
        content = (
            <div className={styles.empty}>No activities found.</div>
        )
    }

    return (
        <div className={[styles.list, className].filter(c => !!c).join(' ')}>
            <div className={styles.filter}>
                <TextField
                    feather='Search'
                    placeholder='Search...'
                    value={searchQuery}
                    onChange={onSearch}
                    onInput={onSearch}
                />
            </div>
            <div className={styles.listScrollWrapper}>
                <ScrollView className={styles.listScroll}>
                    {content}
                </ScrollView>
            </div>
        </div>
    )
}

export default List